import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from "src/modules/auth/store";
import { validationsStore } from "src/modules/validations";

interface IUserAppInfo {
  app_id: number;
  App: string;
  Active: boolean;
  roles: any[];
  deletedRoles: any[];
}

class UsersAdminStore {
  @observable
  public all_users: any[];

  @observable
  public current_user: any;

  @observable
  public all_available_roles: any[];

  @observable
  public loaded: boolean = false;

  @observable
  public allUserEmails: any[];

  constructor() {
    this.getAllUserEmails();
    // this.retrieveUsers();
    this.getAllAvailableRoles();
    this.setBlankUser();
  }

  @action
  public getAuthByID = async (auth_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/get/" + auth_id,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.current_user = responseJson.body;
    this.loaded = true;
  };

  @action
  public retrieveUsers = async () => {
    const response: Response = await fetch(
      // config.BASE_URL + "/api/users/active",
      config.BASE_URL + "/api/users/active",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.all_users = responseJson.body;
    this.loaded = true;
  };

  public getAllUserEmails = async () => {
    const response: Response = await fetch(
      // config.BASE_URL + "/api/users/active",
      config.BASE_URL + "/api/users/all",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.allUserEmails = responseJson.body.map((u: any) => {
      return {
        Email: u.Email,
        auth_id: u.auth_id,
      };
    });
  };

  @action
  public getAllAvailableRoles = async () => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/all_available_roles",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.all_available_roles = responseJson.body;
  };

  @action
  public toggleUserAppAccess(app: IUserAppInfo) {
    const val = app.Active;
    this.current_user.Apps.find(
      (userApp: IUserAppInfo) => userApp.app_id === app.app_id
    ).Active = !val;
    // this.current_user.sites = [2]
  }

  @action
  public togglePharmacyRole = (newRole: any) => {
    // this is getting sent up as an array because I needed to filter the pharma roles to access the full object
    this.current_user.Apps.find((app: IUserAppInfo) => app.app_id === 1).roles =
      newRole;
  };

  @action
  public toggleUniversityRole = (role: any, actionType: string) => {
    const rolesArray = this.current_user.Apps.find(
      (app: IUserAppInfo) => app.app_id === 2
    ).roles;
    const deletedRolesArray = this.current_user.Apps.find(
      (app: IUserAppInfo) => app.app_id === 2
    ).deletedRoles;
    if (actionType === "drop") {
      this.current_user.Apps.find(
        (app: IUserAppInfo) => app.app_id === 2
      ).roles = rolesArray.filter(
        (university_role: any) =>
          university_role.university_role_id !== role.university_role_id
      );
      this.current_user.Apps.find(
        (app: IUserAppInfo) => app.app_id === 2
      ).deletedRoles.push(role);
      validationsStore.runValidator(
        "universityRole",
        this.current_user.Apps.find((app: IUserAppInfo) => app.app_id === 2)
          .roles
      );
    } else {
      let prevRole = this.current_user.Apps.find(
        (app: IUserAppInfo) => app.app_id === 2
      ).roles;

      let UroleName = prevRole.map(elm => {
        return elm.UniversityRoleName;
      });

      let currentRole = [];
      role.forEach(elm => {
        if (!UroleName.includes(elm.UniversityRoleName)) {
          currentRole.push({
            UniversityRoleName: elm.UniversityRoleName,
            role_id: elm.university_role_id,
            university_role_id: elm.university_role_id,
            new: true,
          });
        }
      });
      let combineRoles = prevRole.concat(currentRole);

      let DroleName = role.map(elm => {
        return elm.UniversityRoleName;
      });
      let deletedRole = prevRole.filter(elm => {
        if (!DroleName.includes(elm.UniversityRoleName) && elm) {
          return elm;
        }
      });
      let unselectedRole = deletedRole.concat(currentRole);
      this.current_user.Apps.find(
        (app: IUserAppInfo) => app.app_id === 2
      ).roles = combineRoles;
      this.current_user.Apps.find(
        (app: IUserAppInfo) => app.app_id === 2
      ).deletedRoles = unselectedRole;
      validationsStore.runValidator(
        "universityRole",
        this.current_user.Apps.find((app: IUserAppInfo) => app.app_id === 2)
          .roles
      );
    }
  };

  // @action
  // public toggle

  @action
  public setBlankUser = () => {
    this.current_user = {
      auth_id: undefined,
      Email: "",
      Password: "",
      PasswordConfirm: "",
      FirstName: "",
      LastName: "",
      Phone: "",
      Address: "",
      City: "",
      State: "",
      Zip: "",
      Apps: [
        {
          app_id: 1,
          App: "Pharmacy",
          roles: [],
          Active: false,
          deletedRoles: [],
        },
        {
          app_id: 2,
          App: "University",
          roles: [
            {
              UniversityRoleName: "Student",
              new: true,
              role_id: 4,
              university_role_id: 4,
            },
          ],

          Active: true,
          deletedRoles: [],
        },
        { app_id: 3, App: "Chat", roles: [], Active: false, deletedRoles: [] },
      ],
      Companies: [],
      materialSelectCompanyIDs: [],
      materialSelectSiteIDs: [],
      materialSelectDistributorIDs: [], // D-011
      IntroCoursesComplete: 0,
      PharmacyQualified: 0,
    };
    this.loaded = true;
  };

  @action
  public changeUserPassword = async (auth_id: number, password: string) => {
    const createAuthID = authStore.currentUser.auth_id;
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/change-password",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id,
          password,
        }),
      }
    );
    const result = await response.json();
    return result.success;
  };

  @action
  public saveUser = async (user: any) => {
    const createAuthID = authStore.currentUser.auth_id;
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/save",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          user,
          createAuthID,
        }),
      }
    );
    const result = await response.json();
    // this.saveUser(await result.body);
    await this.retrieveUsers();
    await this.getAllUserEmails();
  };

  @action
  public deleteUser = async (auth_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/delete",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id,
        }),
      }
    );
    await this.retrieveUsers();
  };

  @action
  public enableUser = async (auth_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/users/enable",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id,
        }),
      }
    );
    await this.retrieveUsers();
  };
}

export default new UsersAdminStore();



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/users_admin.store.ts